import { render, staticRenderFns } from "./TabFooter.vue?vue&type=template&id=dc3a3156&scoped=true"
import script from "./TabFooter.vue?vue&type=script&lang=js"
export * from "./TabFooter.vue?vue&type=script&lang=js"
import style0 from "./TabFooter.vue?vue&type=style&index=0&id=dc3a3156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3a3156",
  null
  
)

export default component.exports